import { render, staticRenderFns } from "./klpuInvoice.vue?vue&type=template&id=5d3a440f&scoped=true"
import script from "./klpuInvoice.vue?vue&type=script&lang=js"
export * from "./klpuInvoice.vue?vue&type=script&lang=js"
import style0 from "./klpuInvoice.vue?vue&type=style&index=0&id=5d3a440f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3a440f",
  null
  
)

export default component.exports